import React from 'react'

export default function MovieListHeading(props) {
  return (
    <div className='col'>
        <h1>{props.heading}</h1>
    </div>
  )
}
